var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconLineDetails(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(20262 -2012)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    transform: "translate(-20262 2012)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-20256.646 2018.772)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-3371.994,3396.127a2.011,2.011,0,0,1,2.049-2.209,2.025,2.025,0,0,1,2.087,2.091.81.81,0,0,0,.235.521q1.838,1.486,3.713,2.928a.983.983,0,0,0,.517.134,6.96,6.96,0,0,1,.932.013.645.645,0,0,0,.6-.149q1.832-1.463,3.679-2.908a.664.664,0,0,0,.268-.6,2.019,2.019,0,0,1,1.967-2.034,2,2,0,0,1,2.127,1.694,2.026,2.026,0,0,1-1.381,2.328,6.55,6.55,0,0,1-1.158.076.97.97,0,0,0-.491.125q-1.883,1.461-3.736,2.961a.8.8,0,0,0-.23.524,2.079,2.079,0,0,1-3.218,1.73,2.115,2.115,0,0,1-.954-1.787.741.741,0,0,0-.23-.476q-1.837-1.489-3.705-2.938a1.076,1.076,0,0,0-.526-.136c-.153-.016-.322.061-.465.025a1.019,1.019,0,0,0-1.044.422c-1.233,1.256-2.481,2.5-3.732,3.735a.735.735,0,0,0-.253.645,1.924,1.924,0,0,1-.963,1.952,2.023,2.023,0,0,1-2.251-.061,2.037,2.037,0,0,1-.834-2.189,1.937,1.937,0,0,1,1.941-1.558,1.336,1.336,0,0,0,1.141-.49c1.174-1.2,2.367-2.388,3.562-3.57C-3372.1,3396.679-3371.869,3396.446-3371.994,3396.127Z",
    transform: "translate(3379.075 -3393.915)",
    fill: "currentColor",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-3288.755,3508.606q0-2.795,0-5.59a1.3,1.3,0,0,1,1.391-1.39c.456,0,.912-.008,1.368,0a1.332,1.332,0,0,1,1.369,1.393q0,5.629,0,11.259a1.273,1.273,0,0,1-1.335,1.36c-.5.007-.99.009-1.486,0a1.226,1.226,0,0,1-1.309-1.326Q-3288.756,3511.46-3288.755,3508.606Z",
    transform: "translate(3295.833 -3493.192)",
    fill: "currentColor",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-3104.8,3508.576q0,2.815,0,5.63a1.263,1.263,0,0,1-1.361,1.365c-.482,0-.965.006-1.447,0a1.252,1.252,0,0,1-1.324-1.323q0-5.67,0-11.339a1.3,1.3,0,0,1,1.323-1.347c.508-.018,1.017-.019,1.524,0a1.309,1.309,0,0,1,1.284,1.348Q-3104.8,3505.741-3104.8,3508.576Z",
    transform: "translate(3130.083 -3493.123)",
    fill: "currentColor",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-3195.1,3578.122c0,.885,0,1.771,0,2.656,0,1.068-.463,1.525-1.519,1.525-.43,0-.86,0-1.289,0a1.266,1.266,0,0,1-1.341-1.276q-.029-2.891,0-5.782a1.209,1.209,0,0,1,1.173-1.272,12.883,12.883,0,0,1,1.9.013,1.145,1.145,0,0,1,1.029,1.013,1.655,1.655,0,0,1,.037.271q0,1.426,0,2.852Z",
    transform: "translate(3213.342 -3559.854)",
    fill: "currentColor",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-3375.047,3595.742c0,.717,0,1.434,0,2.151a1.219,1.219,0,0,1-1.253,1.3c-.547.014-1.1.012-1.643,0a1.242,1.242,0,0,1-1.228-1.224q-.025-2.229,0-4.459a1.232,1.232,0,0,1,1.289-1.233c.535,0,1.069,0,1.6,0a1.2,1.2,0,0,1,1.229,1.233C-3375.042,3594.255-3375.047,3595-3375.047,3595.742Z",
    transform: "translate(3379.183 -3576.752)",
    fill: "currentColor",
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLineDetails);
export default __webpack_public_path__ + "static/media/icon-line-details.5c61f4fd.svg";
export { ForwardRef as ReactComponent };